<template>
    <div>
        <van-cell title="用户选择" is-link value="请选择用户" @click="show = true"  v-if="!userFormData.user_id"/>

        <van-cell title="用户选择" is-link value="请选择用户" @click="show = true" v-else>
            <template slot="default">
                <span class="selected">{{userInfo.name}} {{userInfo.phone}}</span>
            </template>
        </van-cell>
        <van-cell
                title="角色类型"
                is-link value="请选择角色类型"
                @click="showPicker = true"
                v-if="!userFormData.type"
        />
        <van-cell
                title="角色类型"
                is-link
                @click="showPicker = true"
                v-else
        >
            <template slot="default">
                <span class="selected">{{userFormData.type}}</span>
            </template>
        </van-cell>

        <div class="savebtn">
            <van-button type="danger" size="large" v-if="!saveLoading" @click="submit">保存</van-button>
            <van-button type="danger" size="large" v-else>保存中...</van-button>
        </div>

        <UserPicker :show="show" :limit="5" @onClonse="onClonse" @onUserAdd="onUserAdd"></UserPicker>
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="roleType"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
            />
        </van-popup>
    </div>
</template>
<style scoped>
    .savebtn {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .selected {
        color: #444;
    }
</style>

<script>
    import Vue from 'vue';
    import {Dialog, Toast, Cell, CellGroup, Picker, Popup} from 'vant';

    Vue.use(Dialog).use(Toast).use(Cell).use(CellGroup).use(Picker).use(Popup);
    import UserPicker from '@/components/business/UserPicker.vue';

    export default {
        name: 'SiteSettingUserCreate',
        components: {
            UserPicker
        },
        data: function () {
            return {
                businessUserList: [],
                saveLoading: false,
                show: false,
                showPicker: false,
                roleType: ['管理员', '工作人员'],
                userFormData: {
                    user_id: undefined,
                    type: '管理员',
                },
                userInfo: []
            }
        },
        filter: {},
        mounted() {
            document.title = "新增人员"
        },
        destroyed() {
        },
        methods: {
            submit() {
                let that = this;

                that.formValidate = true;
                console.log('that.formData', that.userFormData);


                if(!that.userFormData.user_id){
                    Toast('请选择人员')
                    return ;
                }
                if(!that.userFormData.type){
                    Toast('请选择类型')
                    return ;
                }

                that.saveLoading = true;
                that.$api.post('/wyhadminapi/weiyuanhui/addWyhUser', that.userFormData, (res) => {
                    Toast.success('新增成功');
                    // that.$router.go(-1)
                    rbLink({
                        name: "SiteSettingUser"
                    }, 'back')

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },

            onConfirm(value) {
                console.log(value)
                this.userFormData.type = value
                this.showPicker = false;
            },

            onClonse() {
                this.show = false;
                console.log('onClonse', this.userInfo)
            },

            onUserAdd(data) {
                console.log('--onUserAdd--', data)

                let that = this;
                that.userFormData.user_id = data.id;

                that.userInfo = data;
                that.show = false
            }

        }

    }
</script>



// WEBPACK FOOTER //
// SiteSettingUserCreate.vue?496063f9